import { OptionChain } from 'constants/opc';

export function getAvailableStrikes(
  chain: OptionChain | undefined,
  ticker: string,
  expirationKey: string,
  optionType: 'CALL' | 'PUT',
): number[] {
  if (!chain || !chain[ticker]) {
    return [];
  }

  const expiration = chain[ticker]?.entries?.find((entry) => entry.e === expirationKey);
  if (!expiration || !expiration.c) {
    return [];
  }

  const strikes: number[] = [];
  const strikeData = expiration.c;

  Object.keys(strikeData).forEach((strikeStr) => {
    const strike = Number(strikeStr);
    const strikeOptions = strikeData[strike];

    if (!strikeOptions) return;

    const hasOption = optionType === 'CALL' ? strikeOptions.c : strikeOptions.p;
    if (hasOption) {
      strikes.push(strike);
    }
  });

  return strikes.toSorted((a, b) => a - b);
}
